import React, { FC, HTMLAttributes } from "react";
import "./style.scss";
import OnlineOrderReconciliation from "../online-order-reconciliation";
import PnlStatement from "../pnl-statement";
import { ACCOUNTING_TABS_MAP } from "../../../data/accounting-constants";
import { useParams } from "react-router-dom";
import CashManagement from "../cash-management";
import CashierSettlement from "../cashier-settlement";
import AccountSummary from "../account-summary"
import XMLGenerator from "../xml-generator";
import { haveReconEngineAccess } from "../../../helpers/accounting-helper";
import SalesAuditLog from "../sales-audit";

const AccountingComponent: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const { subTabId = "" } = useParams();

  function renderSelectedTab() {
    switch (subTabId) {
      case ACCOUNTING_TABS_MAP.online_order_reconciliation.tabId:
        // TODO: ONLINE_RECON - This check is just for testing and needs to changed in future.
        if (haveReconEngineAccess()) {
          return <OnlineOrderReconciliation />;
        }
        return  <></>;
      case ACCOUNTING_TABS_MAP.cash_management.tabId:
        return <CashManagement />;
      case ACCOUNTING_TABS_MAP.cashier_settlement.tabId:
        return <CashierSettlement />;
      case ACCOUNTING_TABS_MAP.xml_generator.tabId:
        return <XMLGenerator />;
      case ACCOUNTING_TABS_MAP.pnl_statement.tabId:
        return <PnlStatement />;
      case ACCOUNTING_TABS_MAP.account_summary.tabId:
        return <AccountSummary />;
      case ACCOUNTING_TABS_MAP.sales_audit.tabId:
        return <SalesAuditLog/>
      default:
        return <></>;
    }
  }

  return renderSelectedTab();
};

export default AccountingComponent;
